import axios from 'axios';

const executeApi = async (payload) => {
  const response = await axios.post('/api/api-explorer/execute', payload);
  return response.data;
};

export default {
  executeApi
};
